import InfiniteScroll from "react-infinite-scroll-component";
import {useMatchWalletRecords, useWallet, useMatchChain, useReceipt} from "../../hooks";
import {Address, UserTransactionType} from "../../types";
import {ReactNode, useEffect, useMemo, useState} from "react";
import {ArrowSendIcon, CheckRoundIcon, InfoRoundIcon, LoadingIcon} from "../../assets/icon";
import {formatAddress, formatDate, NumberFormatter,} from "../../utils";
import {decodeFunctionData, defineChain, formatUnits} from "viem";
import {erc20Abi} from "viem";
import useContractStore from "../../store/useContractStore";
import {TransactionInfo} from "../../store/useTransactionStore";
import useHash from "../../hooks/useHash";
import {FormattedMessage} from "react-intl";

const Item = ({data}: { data: UserTransactionType | TransactionInfo }) => {
    const {address} = useWallet()
    const isOut = data.from.toLowerCase() == address.toLowerCase()

    const {chain, chainId, explorerLink, formatUnits: chainFormatUnits} = useMatchChain()
    const {contracts} = useContractStore()
    const [shouldRefetch,setShouldRefetch] = useState(true)

    // const receiptQuery = useReceipt({
    //     chainId: chain?.id || 698,
    //     hash: data.hash
    // })
    const transferType = useMemo(() => {
        const methodId = data.input.substring(2, 10)
        if (methodId == "095ea7b3") {
            return "erc20_approve"
        }
        if (methodId == "a9059cbb") {
            return "erc20_transfer"
        }
        return "unknown"
    }, [data.input])

    const to = useMemo(() => {
        if(!isOut){
            return data.from
        }
        if (transferType == "erc20_transfer") {
            const decodeData = decodeFunctionData({
                abi: erc20Abi,
                data: data.input,
            })
            return decodeData.args[0] as Address
        }
        return data.to
    }, [data.input, transferType, data.to,isOut])

    const amount = useMemo(() => {
        if (transferType == "erc20_transfer") {
            const decodeData = decodeFunctionData({
                abi: erc20Abi,
                data: data.input,
            })
            const value = decodeData.args[1] as bigint
            return formatUnits(value, contracts[`${chainId}-${data.to.toLowerCase()}`]?.decimals || 18)
            // return value.toString();
        }
        return chainFormatUnits(BigInt(data.value))
    }, [data.input, transferType, data.value, contracts, chainId, data.to])

    const hashQuery = useHash({
        hash:data.hash,
        //@ts-ignore
        chain:defineChain(chain),
        refetchInterval: shouldRefetch ? 3000 : false,
        enabled:shouldRefetch && data.source == 'local'
    })
    const status = useMemo(() => {
        if (data.source == 'matchain') {
            switch (data.extra.status) {
                case "ok":
                    return "success"
                case "error":
                    return "error"
            }

        } else if(data.source=='auto') {
            if (data.extra.receipt_status == 1) {
                return "success"
            } else {
                return "error"
            }
        }else {
            if(hashQuery.data==1){
                return 'success'
            }
            if(hashQuery.data==-1){
                return 'error'
            }
            if(Date.now()/1000-parseInt(data.timestamp)>3600){
                return 'error'
            }
        }

        return 'loading'
    }, [data.extra?.status, data.source,hashQuery.data])

    useEffect(() => {
        if(data.hash){
            setShouldRefetch(status=='loading')
        }
    }, [status,data.hash]);

    const symbol = useMemo(() => {
        if (transferType == "erc20_transfer") {
            const contract = contracts[`${chainId}-${data.to.toLowerCase()}`]
            return contract?.symbol || contract?.name || "unknown"
        }
        return chain?.nativeCurrency.symbol || chain?.nativeCurrency.name
    }, [transferType, chain, contracts, chainId, data.to])


    return <a
        href={explorerLink(`tx/${data.hash}`)}
        target="_blank"
        className={`matchid-transaction-item`}
    >
        <div className={`matchid-transacton-item-container`}>
            <div className={"matchid-transaction-item-icon"}>
                <ArrowSendIcon className={!isOut ? "rotate-180" : ""}/>
            </div>
            <div className={`matchid-transaction-item-details`}>
                <div className={`matchid-transaction-item-address`}>
                    {formatAddress(to, 6, 4)}
                </div>
                <div
                    className={`matchid-transaction-item-timestamp`}>{formatDate(data.timestamp, 'MM/DD HH:mm:ss')}</div>
            </div>
        </div>
        <div className={`matchid-transaction-item-amount ${'matchid-transaction-item-' + status}`}>
            <NumberFormatter value={amount} tFixNum={6} prefix={isOut ? '-' : '+'} suffix={" " + symbol}/>

            {status == 'loading' && <LoadingIcon color="#000000" size={16} rotate/>}
            {status == 'success' && <CheckRoundIcon size={16}/>}
            {status == 'error' && <InfoRoundIcon size={16}/>}

        </div>
    </a>
}

export default function TransactionList({
                                            scrollableTarget
                                        }: {
    scrollableTarget?: ReactNode;
}) {
    const {fetchMoreData, hasMore, items} = useMatchWalletRecords()

    return (
        <InfiniteScroll
            scrollableTarget={scrollableTarget}
            dataLength={items.length}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={<div className={"matchid-list-nomore"}><LoadingIcon rotate size={16} color={"black"}/>Loading...
            </div>}
            endMessage={
                items.length > 0 ?
                    <div className={`matchid-list-nomore`}><FormattedMessage id={"noMoreRecords"}/></div> :
                    <div className={`matchid-list-nomore`}><FormattedMessage id={"noRecords"}/></div>
            }
        >
            {
                items.length == 0 && !hasMore ?
                    <div className={"mt-[150px]"}/> :
                    <div className={`matchid-transaction-list`}>
                        {
                            items.map((item, index) => <Item data={item} key={index}/>)
                        }
                    </div>
            }
        </InfiniteScroll>
    )
}